export default __webpack_public_path__ + "static/media/porcentaje_rojo.4ddec0d9.svg";